const regExp = RegExp(/\S+@\S+\.\S+/)

const isEmailValid = (email: string): boolean => {
  return regExp.test(email)
}

export default isEmailValid
